<template>
  <div class="page-btns">
    <div v-show="showUpload">
      <el-upload
        :headers="headers"
        class="upload-demo"
        :action="uploadUrl"
        :before-upload="handlePreview"
        :on-success="handleSuccess"
        :multiple="multiple"
        :limit="limit"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :show-file-list="false"
        :accept="accept"
      >
        <el-button>
          <svg-icon icon-class="tn-upload" style="margin-right: 4px" />
          Upload file
        </el-button>
        <!-- <div slot="tip" class="el-upload__tip"></div> -->
      </el-upload>
    </div>

    <div v-for="(file, index) in fileList" :key="index" class="spaceLeft file-list-item">
      <div>{{ file.name }}</div>
      <svg-icon icon-class="tn-delete" @click="handleRemove(index)" />
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { conver } from "@/utils/index";
export default {
  props: {
    multiple: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    limit: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    readonly: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    accept: {
      type: String,
      default: () => {
        return ".pdf,.PDF";
      },
    },
    defaultFileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_FILE_API + "/api/file/upload",
      fileList: [],
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      showUpload: true,
    };
  },
  watch: {
    defaultFileList: {
      immediate: true,
      handler: function(val){
        this.fileList = val
        if (!this.multiple && val.length > 0) {
          this.showUpload =  false;
        }else{
          this.showUpload =  true;
        }
      },
    },
  },
  // computed: {
  //   showUpload() {
  //     if (!this.multiple && this.fileList.length > 0) {
  //       return false;
  //     }
  //     return true;
  //   },
  // },
  methods: {
    handleSuccess(response, file, fileList) {
      fileList.forEach((i, index) => {
        fileList[index].name = i.response && i.response.result.fileName;
      });
      this.fileList = fileList;
      this.$emit("onSuccess", { response, file, fileList });
    },
    handleRemove(index) {
      this.fileList.splice(index, 1);
      this.$emit("onRemove", this.fileList);
    },
    handlePreview(file) {
      let size = file.size || 0;
      if (size > 1024 * 1024 * 5) {
        this.$message.warning("The uploaded file cannot exceed 5 megabytes");
        this.fileList = [];
        return false;
      }
      return true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`Login status has expired, please log in again!`);
    },
    setFile(file) {
      this.fileList = [];
      this.fileList.push({ name: file });
    },
    setFiles(fileList) {},
  },
};
</script>
<style scoped lang="scss">
.file-list-item {
  color: #c6c6c6;
  font-size: 0.18rem;
  & > div {
    color: #1a59f6;
  }
  & > svg {
    cursor: pointer;
    margin-left: 0.28rem;
  }
}
</style>
